import { h, Component } from 'preact';
import cx from 'classnames';
import Markup from 'preact-markup';
import dlv from 'dlv';

import style from './style';

import { Icon, Button } from '@cube/blocks';
import { trackEvent, INPUT_KEYS, DIMENSION, EVENT, INTERACTION } from '@cube/track';
import { assetLink } from '@cube/utils';

const moreText = 'More';

export class Alert extends Component {

	handleClick = (e) => {
		let { alert } = this.props,
			href = assetLink(alert.cta_url);

		trackEvent(this.context, {
			[INPUT_KEYS.action]: EVENT.click,
			[DIMENSION.interaction]: INTERACTION.open,
			[DIMENSION.componentpath]: 'Notifications.Alert',
			[DIMENSION.contentid]: dlv(alert, 'metadata.id'),
			[DIMENSION.contentgroup]: (alert.type === 'promo' ? 'promo' : 'breaking_news'),
			[DIMENSION.linkurl]: href
		});
	};

	componentDidMount() {
		let { alert } = this.props;
		trackEvent(this.context, {
			[INPUT_KEYS.action]: EVENT.impression,
			[DIMENSION.componentpath]: 'Notifications.Alert',
			[DIMENSION.contentid]: dlv(alert, 'metadata.id'),
			[DIMENSION.contentgroup]: (alert.type === 'promo' ? 'promo' : 'breaking_news')
		});
	}

	render({ alert, alertsText, alertClass, layout, onDismiss }) {
		let isPromo = alert.type === 'promo',
			buttonText = alert.cta_text,
			alertText = alert.alert_text,
			href = assetLink(alert.cta_url);

		let hrefAttrbs;
		if (alert.cta_url) {
			hrefAttrbs = alert.cta_url.open_new_window ? { target: '_blank', rel: 'noopener noreferrer' } : { rel: 'noopener noreferrer' };
		}

		// If a link is provided and no button text then default to MORE
		if (!buttonText && href) buttonText = moreText;

		return (
			<div onClick={this.handleClick} class={cx(style.scAlert, isPromo ? style.promo : style.news, alertClass, style[layout])} data-tb-region-item>
				<a
					href={href}
					{...hrefAttrbs}
				>
					<div class={style.message}>
						<div class={style.title}>
							<Markup markup={alertText} type="html" trim={false} />
						</div>
						<div class={style.controls}>
							{ layout !== 'phone' && href &&
								<Button class={cx(style.button, !href && style.nolink)}>{buttonText}</Button>
							}
							<Dismiss
								onClick={onDismiss}
								alert={alert}
								isPromo={isPromo}
								icon="exit-wire-cube"
							/>
						</div>
					</div>
				</a>
			</div>
		);
	}
}

export class Dismiss extends Component {
	handleClick = (e) => {
		e.preventDefault();
		e.stopPropagation();

		let { alert, onClick, isPromo } = this.props,
			href = assetLink(alert.cta_url);

		trackEvent(this.context, {
			[INPUT_KEYS.action]: EVENT.click,
			[DIMENSION.interaction]: INTERACTION.dismiss,
			[DIMENSION.componentpath]: 'Notifications.Alert',
			[DIMENSION.contentid]: dlv(alert, 'metadata.id'),
			[DIMENSION.contentgroup]: (!isPromo ? 'breaking_news' : 'promo'),
			[DIMENSION.linkurl]: href
		});

		onClick && onClick(alert);
	};

	render({ isPromo, icon='exit-wire-cube' }) {
		return (
			<button
				class={cx(style.dismiss, isPromo ? style.promo : style.news)}
				onClick={this.handleClick}
			>
				<Icon name={icon} />
			</button>
		);
	}
}
